import { render, staticRenderFns } from "./SubstanceSelect.vue?vue&type=template&id=34745398&scoped=true&"
import script from "./SubstanceSelect.vue?vue&type=script&lang=js&"
export * from "./SubstanceSelect.vue?vue&type=script&lang=js&"
import style0 from "./SubstanceSelect.vue?vue&type=style&index=0&id=34745398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34745398",
  null
  
)

export default component.exports